import { UserRole } from 'types/user.types';

export interface RouteConfig {
  path: string;
  title: string;
  icon?: string;
  roles?: UserRole[];
  hideInMenu?: boolean;
  children?: RouteConfig[];
}

export const ROUTES = {
  LOGIN: '/login',
  RESET_PASSWORD: '/reset-password',

  DASHBOARD: '/',

  APPLICATIONS: '/applications',
  APPLICATION_CREATE: '/applications/create',
  APPLICATION_DETAIL: '/applications/:id',
  APPLICATION_EDIT: '/applications/:id/edit',
  APPLICATION_USERS: '/applications/:id/users',

  PUSH_CENTER: '/push-center',
  PUSH_SEND: '/push-center/send',
  PUSH_DETAIL: '/push-center/history/:messageId',
  PUSH_GROUP_DETAIL: '/push-center/history/group/:groupKey',

  CAMPAIGN_CREATE: '/push-center/campaigns/create',
  CAMPAIGN_DETAIL: '/push-center/campaigns/:id',
  CAMPAIGN_EDIT: '/push-center/campaigns/:id/edit',

  GLOBAL_CAMPAIGNS: '/global/campaigns',
  GLOBAL_CAMPAIGN_CREATE: '/global/campaigns/create',
  GLOBAL_CAMPAIGN_DETAIL: '/global/campaigns/:id',
  GLOBAL_CAMPAIGN_EDIT: '/global/campaigns/:id/edit',

  EVENT_TRIGGER_CREATE: '/push-center/triggers/create',
  EVENT_TRIGGER_DETAIL: '/push-center/triggers/:id',
  EVENT_TRIGGER_EDIT: '/push-center/triggers/:id/edit',

  RECURRING_SCHEDULE_CREATE: '/push-center/schedules/create',
  RECURRING_SCHEDULE_DETAIL: '/push-center/schedules/:id',
  RECURRING_SCHEDULE_EDIT: '/push-center/schedules/:id/edit',

  AB_TEST_CREATE: '/push-center/ab-tests/create',
  AB_TEST_RESULTS: '/push-center/ab-tests/:id',
  AB_TEST_EDIT: '/ab-tests/:id/edit',

  SEGMENT_CREATE: '/push-center/segments/create',
  SEGMENT_DETAIL: '/push-center/segments/:id',
  SEGMENT_EDIT: '/push-center/segments/:id/edit',

  GLOBAL_SEGMENTS: '/global/segments',
  GLOBAL_SEGMENT_CREATE: '/global/segments/create',
  GLOBAL_SEGMENT_DETAIL: '/global/segments/:id',
  GLOBAL_SEGMENT_EDIT: '/global/segments/:id/edit',

  TEMPLATES: '/templates',
  TEMPLATE_CREATE: '/templates/create',
  TEMPLATE_DETAIL: '/templates/:id',
  TEMPLATE_EDIT: '/templates/:id/edit',

  STATISTICS: '/statistics',
  STATISTICS_APP: '/statistics/app/:id',
  STATISTICS_PUSH: '/statistics/push/:messageId',
  STATISTICS_CAMPAIGN: '/statistics/campaign/:id',

  USERS: '/users',
  USER_CREATE: '/users/create',
  USER_DETAIL: '/users/:id',
  USER_EDIT: '/users/:id/edit',

  NOT_FOUND: '*',
};

export const menuConfig: RouteConfig[] = [
  {
    path: ROUTES.DASHBOARD,
    title: 'Панель управления',
    icon: 'DashboardOutlined',
    roles: [UserRole.ADMIN],
  },
  {
    path: ROUTES.APPLICATIONS,
    title: 'Приложения',
    icon: 'AppstoreOutlined',
    roles: [UserRole.ADMIN],
    children: [
      {
        path: ROUTES.APPLICATIONS,
        title: 'Все приложения',
      },
      {
        path: ROUTES.APPLICATION_CREATE,
        title: 'Создать приложение',
        roles: [UserRole.ADMIN],
      },
    ],
  },

  {
    path: ROUTES.PUSH_CENTER,
    title: 'Управление Push',
    icon: 'RocketOutlined',
    roles: [UserRole.ADMIN, UserRole.EXECUTOR, UserRole.ACC_MANAGER, UserRole.VIEWER, UserRole.BUYER],
  },

  {
    path: ROUTES.TEMPLATES,
    title: 'Шаблоны',
    icon: 'BookOpenIcon',
    roles: [UserRole.ADMIN, UserRole.EXECUTOR],
    children: [
      {
        path: ROUTES.TEMPLATES,
        title: 'Все шаблоны',
      },
      {
        path: ROUTES.TEMPLATE_CREATE,
        title: 'Создать шаблон',
      },
    ],
  },

  {
    path: ROUTES.STATISTICS,
    title: 'Статистика',
    icon: 'BarChartOutlined',
    roles: [UserRole.ADMIN, UserRole.EXECUTOR],
  },

  {
    path: ROUTES.USERS,
    title: 'Пользователи',
    icon: 'UserOutlined',
    roles: [UserRole.ADMIN],
    children: [
      {
        path: ROUTES.USERS,
        title: 'Все пользователи',
      },
      {
        path: ROUTES.USER_CREATE,
        title: 'Создать пользователя',
      },
    ],
  },

  {
    path: ROUTES.GLOBAL_SEGMENTS,
    title: 'Глобальные',
    icon: 'GlobalOutlined',
    roles: [UserRole.ADMIN],
    children: [
      {
        path: ROUTES.GLOBAL_SEGMENTS,
        title: 'Сегменты',
      },
      {
        path: ROUTES.GLOBAL_CAMPAIGNS,
        title: 'Кампании',
      },
    ],
  },

];

export const generatePath = (path: string, params?: Record<string, string | number>): string => {
  if (!params) return path;

  let generatedPath = path;
  Object.entries(params).forEach(([key, value]) => {
    generatedPath = generatedPath.replace(`:${key}`, String(value));
  });

  return generatedPath;
};